import { jsx as _jsx } from "react/jsx-runtime";
import { useAuth } from "@/app";
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
export const ProtectedRoute = ({ children, requireAuth = false, }) => {
    const { isAuthenticated, isGuest, isLoading } = useAuth();
    const location = useLocation();
    // Пока идёт первичная проверка авторизации — НЕ редиректим. Возврат с оплаты
    // (и любая защищённая страница) открывается полной перезагрузкой, где на
    // первых кадрах isAuthenticated и isGuest ещё false; без этой проверки
    // /payment/success успевал улететь на "/" → /generate-song ДО того, как
    // смонтируется PaymentSuccessPage, и резюм создания песни после оплаты
    // терялся. Рендерим детей — они сами работают по cookie-сессии.
    if (isLoading) {
        return children;
    }
    // Гостевой чекаут: гость — полноценный пользователь (может покупать/платить),
    // поэтому пускаем в приложение по «авторизован ИЛИ гость».
    //
    // Уводя на "/", ОБЯЗАТЕЛЬНО тащим с собой search и hash. Голый
    // `<Navigate to="/">` затирал их безвозвратно, а на них держится весь вход по
    // кнопке бота: в `search` лежит `?audioId=<id>` (какой трек открывать), в
    // `hash` — подписанная initData мини-аппа (`#tgWebAppData=…`, `#WebAppData=…`),
    // по которой приложение вообще авторизуется. Потеряв их, HomeRoute уводил
    // гостя на `/generate-song` без единого шанса вернуться — ровно тот симптом
    // «с телефона выкидывает на создание песни». `state.from` оставляем, чтобы
    // экран входа мог вернуть человека на исходную страницу.
    if (requireAuth && !isAuthenticated && !isGuest) {
        return (_jsx(Navigate, { to: { pathname: "/", search: location.search, hash: location.hash }, state: { from: location }, replace: true }));
    }
    return children;
};
